import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {SampleForm, SampleFormInput} from './sample-form.model';

export const loadSampleForms = createAction(
  '[SampleForm/API] Load SampleForms',
  props<{ sampleForms: SampleForm[] }>()
);

export const addSampleForm = createAction(
  '[SampleForm/API] Add SampleForm',
  props<{ sampleForm: SampleForm }>()
);

export const upsertSampleForm = createAction(
  '[SampleForm/API] Upsert SampleForm',
  props<{ sampleForm: SampleForm }>()
);

export const addSampleForms = createAction(
  '[SampleForm/API] Add SampleForms',
  props<{ sampleForms: SampleForm[] }>()
);

export const upsertSampleForms = createAction(
  '[SampleForm/API] Upsert SampleForms',
  props<{ sampleForms: SampleForm[] }>()
);

export const updateSampleForm = createAction(
  '[SampleForm/API] Update SampleForm',
  props<{ sampleForm: Update<SampleForm> }>()
);

export const updateSampleForms = createAction(
  '[SampleForm/API] Update SampleForms',
  props<{ sampleForms: Update<SampleForm>[] }>()
);

export const deleteSampleForm = createAction(
  '[SampleForm/API] Delete SampleForm',
  props<{ id: string }>()
);

export const deleteSampleForms = createAction(
  '[SampleForm/API] Delete SampleForms',
  props<{ ids: string[] }>()
);

export const clearSampleForms = createAction(
  '[SampleForm/API] Clear SampleForms'
);


// CUSTOM
export const createSampleForm = createAction(
  '[SampleForm/API] Create SampleForm',
  props<{ input: SampleFormInput }>()
);

export const editSampleForm = createAction(
  '[SampleForm/API] Edit SampleForm',
  props<{ input: SampleFormInput }>()
);

export const removeSampleForm = createAction(
  '[SampleForm/API] Remove SampleForm',
  props<{ sampleFormUniqueId: string, id: string }>()
);

export const getSampleForms = createAction(
  '[SampleForm/API] get SampleForms',
  props<{ formUniqueId?: any }>()
);

// citizen
export const citizenGetServiceSampleForm = createAction(
  '[SampleForm/API] citizen get SampleForms',
  props<{ formUniqueId?: string }>()
);
